import { createContext, useContext } from 'react'
import type { Access } from '../shared/types'

export const AccessContext = createContext<Access | null>(null)

/** The signed-in person's role and screens, from GET /api/me. Only available inside the signed-in app. */
export function useAccess(): Access {
  const a = useContext(AccessContext)
  if (!a) throw new Error('useAccess outside the signed-in app')
  return a
}
